import PageHeading from 'elements/PageHeading';
import Pattern from 'elements/Pattern';
import { useAuth } from 'providers/AuthProvider';

const digitalAttendanceUrl = process.env.REACT_APP_DIGITAL_ATTENDANCE_URL
    || 'https://www.furgediak.hu/digitalisjelenletiiv/';

export default function DigitalAttendancePage() {
    const { token } = useAuth();
    const iframeSrc = token
        ? `${digitalAttendanceUrl}?token=${encodeURIComponent(token)}`
        : null;

    return (
        <div className="relative flex min-h-screen w-full flex-col items-center overflow-hidden gradient-green px-site py-site">
            <Pattern className="pointer-events-none opacity-60" />

            <div className="relative z-10 flex w-full max-w-boxed flex-col gap-8">
                <PageHeading
                    title="Digitális jelenléti íveim"
                    subTitle="Itt éred el a munkáidhoz tartozó digitális jelenléti íveket és rögzített jelenléti adataidat."
                    align="left"
                    mobileAlign="center"
                />

                {iframeSrc && (
                    <iframe
                        src={iframeSrc}
                        className="block min-h-[75dvh] w-full overflow-hidden rounded-3xl bg-transparent shadow-2xl"
                        title="Digitális jelenléti ívek"
                        allowFullScreen
                    ></iframe>
                )}
            </div>
        </div>
    );
}
